export default __webpack_public_path__ + "static/media/gallery - potions_06.de77acf1.jpg";